import { GetServerSideProps } from "next";
import { ProfilePage } from "../../features/profile/profile-page/profile-page";
import {
  ProfileSSRParams,
  ProfileSSRProps,
} from "../../features/profile/profile-page/api";
import { getAuth0AccessToken } from "../../lib/auth0";
import { withLogging } from "../../lib/ssr/logGetServerSideProps";

export default ProfilePage;

export type GetProfileServerSideProps = GetServerSideProps<
  ProfileSSRProps,
  ProfileSSRParams
>;

export const getServerSideProps: GetProfileServerSideProps = withLogging(
  async ({ req, res, params, query }) => {
    const accessToken = await getAuth0AccessToken(req, res);
    const props = await ProfilePage.prefetchData(params, accessToken);

    const profile = props.profile;

    if (query.direct && query.r) {
      return {
        redirect: {
          statusCode: 301,
          destination: `/plan?r=${query.r}`,
        },
      };
    }

    if (profile) {
      //  Handling for sub forests access directly - will do nothing is not a subforest or full url has been specified
      if (
        profile.isChildProfile &&
        params.usernameOrId &&
        !params.childUsernameOrId
      ) {
        //  The user is attempting to access a subforest profile directly (ecologi.com/child) instead of the
        //  full url (ecologi.com/parent/child) so we need to redirect them
        return {
          redirect: {
            statusCode: 301,
            destination: `/${profile.parentProfile.username}/${profile.username}`,
          },
        };
      }

      // Case-insensitive username search, we want to re-direct to properly cased username
      if (
        // Confirm searching by username
        profile.username.toLowerCase() == params.usernameOrId.toLowerCase() &&
        // Confirm casing is different
        profile.username !== params.usernameOrId
      ) {
        return {
          redirect: {
            statusCode: 301,
            destination: `/${profile.username}`,
          },
        };
      }
    }

    return {
      props: { ...props, accessToken },
    };
  }
);
